function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React, { useContext, useState, useEffect } from "react";
import { injectTestId } from "@cvent/nucleus-test-automation";
import ThemeContext from "../../ThemeProvider/ThemeContext";
import ChevronUpIcon from "../../Icon/ChevronUp";
import ChevronDownIcon from "../../Icon/ChevronDown";
import useStyle from "./SideNavigationMenu.style";
export var SideNavigationMenu = function(param) {
    var children = param.children, testID = param.testID, tmp = param.isOpen, isOpenProp = tmp === void 0 ? false : tmp, title = param.title, onClick = param.onClick, _isRtl = param.isRtl, isRtl = _isRtl === void 0 ? false : _isRtl;
    var handleOnClick = function() {
        var isOpenAfterClick = !isOpen;
        setIsOpen(isOpenAfterClick);
        if (onClick) {
            onClick(isOpenAfterClick);
        }
    };
    var ref = _slicedToArray(useState(isOpenProp), 2), isOpen = ref[0], setIsOpen = ref[1];
    var font = useContext(ThemeContext).font;
    var ref1 = useStyle(isRtl), triggerStyles = ref1.triggerStyles, listStyles = ref1.listStyles;
    useEffect(function() {
        setIsOpen(isOpenProp);
    }, [
        isOpenProp
    ]);
    return _jsxs("li", {
        css: {
            listStyle: 'none'
        },
        children: [
            _jsxs("div", _objectSpread({}, injectTestId(testID), {
                css: triggerStyles,
                onClick: handleOnClick,
                onKeyPress: function(e) {
                    if (e.key === 'Enter') setIsOpen(!isOpen);
                },
                tabIndex: 0,
                role: "button",
                "aria-controls": title,
                "aria-haspopup": true,
                "aria-expanded": isOpen,
                children: [
                    _jsx("span", {
                        children: title
                    }),
                    isOpen ? _jsx(ChevronUpIcon, {
                        size: "m",
                        color: font.color.soft
                    }) : _jsx(ChevronDownIcon, {
                        size: "m",
                        color: font.color.soft
                    })
                ]
            })),
            isOpen && _jsx("ul", {
                id: "".concat(title),
                css: listStyles,
                children: children
            })
        ]
    });
};
export default SideNavigationMenu;
